import api from "./api";

const buildQuery = (params) => {
  const cleaned = Object.entries(params)
    .filter(([_, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return cleaned ? `?${cleaned}` : "";
};

const wrap = async (promise) => {
  try {
    const res = await promise;
    return res.data;
  } catch (err) {
    const msg = err.response?.data?.detail 
      || err.response?.data?.name?.[0]  // DRF validation error on 'name'
      || err.response?.data 
      || err.message;
    throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
  }
};

// ---------------- FARMS ----------------
export const fetchFarms = () => wrap(api.get("/ghse/farms/"));
export const fetchFarm = (id) => wrap(api.get(`/ghse/farms/${id}/`));
export const createFarm = (data) => wrap(api.post("/ghse/farms/", data));
export const updateFarm = (id, data) => wrap(api.patch(`/ghse/farms/${id}/`, data));
export const deleteFarm = (id) => wrap(api.delete(`/ghse/farms/${id}/`));

// ---------------- ZONES ----------------
export const fetchZones = (farmId) => wrap(api.get(`/ghse/zones/${buildQuery({ farm: farmId })}`));
export const fetchZone = (id) => wrap(api.get(`/ghse/zones/${id}/`));
export const createZone = (data) => wrap(api.post("/ghse/zones/", data));
export const updateZone = (id, data) => wrap(api.patch(`/ghse/zones/${id}/`, data));
export const deleteZone = (id) => wrap(api.delete(`/ghse/zones/${id}/`));

// ---------------- GHSE ----------------
export const fetchGHSEs = (farmId, zoneId = null) => 
  wrap(api.get(`/ghse/ghses/${buildQuery({ farm: farmId, zone: zoneId })}`));
export const fetchGHSE = (id) => wrap(api.get(`/ghse/ghses/${id}/`));
export const createGHSE = (data) => wrap(api.post("/ghse/ghses/", data));
export const updateGHSE = (id, data) => wrap(api.patch(`/ghse/ghses/${id}/`, data));
export const deleteGHSE = (id) => wrap(api.delete(`/ghse/ghses/${id}/`));

// ---------------- BAYS ----------------
export const fetchBays = (ghseId) => wrap(api.get(`/ghse/bays/${buildQuery({ ghse: ghseId })}`));
export const fetchBay = (id) => wrap(api.get(`/ghse/bays/${id}/`));
export const createBay = (data) => wrap(api.post("/ghse/bays/", data));
export const updateBay = (id, data) => wrap(api.patch(`/ghse/bays/${id}/`, data));
export const deleteBay = (id) => wrap(api.delete(`/ghse/bays/${id}/`));